import { createPortal } from 'react-dom';
import { useActionsPortal, useEditingActionsPortal } from './Panel';

/**
 * A portal component that allows a panel child to add actions to the panel header.
 */
export default function PanelActions({ children }) {
    const el = useActionsPortal();

    if (!el) return null;

    return createPortal(children, el);
}

export function PanelEditingActions({ children }) {
    const el = useEditingActionsPortal();

    if (!el) return null;

    return createPortal(children, el);
}
